var exports = {
  "i": "SecurityTab.module__warningText___T2RTZE",
  "H": "SecurityTab.module__claimButton___T2RTZE",
};

module.exports = exports;
